import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full min-w-0" }
const _hoisted_2 = { class: "hidden lg:block w-full min-w-0" }
const _hoisted_3 = { class: "overflow-x-auto overscroll-x-contain rounded-b-lg border-t border-slate-100" }
const _hoisted_4 = { class: "w-full min-w-[58rem] border-separate border-spacing-0 text-left" }
const _hoisted_5 = { class: "sticky top-0 z-20 shadow-[0_1px_0_0_rgb(0_0_0/0.08)]" }
const _hoisted_6 = { class: "flex items-center gap-1.5" }
const _hoisted_7 = {
  class: "w-3.5 h-3.5 shrink-0",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_8 = ["d"]
const _hoisted_9 = { class: "flex items-center gap-1.5" }
const _hoisted_10 = {
  class: "w-3.5 h-3.5 shrink-0",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_11 = ["d"]
const _hoisted_12 = { class: "flex items-center gap-1.5" }
const _hoisted_13 = {
  class: "w-3.5 h-3.5 shrink-0",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_14 = ["d"]
const _hoisted_15 = { class: "divide-y divide-slate-100 bg-white" }
const _hoisted_16 = { class: "px-3 py-3 align-top text-slate-500 text-sm" }
const _hoisted_17 = { class: "px-3 py-3 align-top min-w-0" }
const _hoisted_18 = { class: "font-semibold text-slate-900 text-sm leading-snug line-clamp-2" }
const _hoisted_19 = ["title"]
const _hoisted_20 = { class: "px-3 py-3 text-slate-600 align-top" }
const _hoisted_21 = { class: "text-sm" }
const _hoisted_22 = { class: "px-3 py-3 align-top" }
const _hoisted_23 = {
  key: 1,
  class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-500"
}
const _hoisted_24 = { class: "px-3 py-3 align-top tabular-nums text-sm font-bold text-slate-900" }
const _hoisted_25 = { class: "px-3 py-3 align-top" }
const _hoisted_26 = ["title"]
const _hoisted_27 = { class: "px-3 py-3 text-xs text-slate-600 align-top whitespace-nowrap" }
const _hoisted_28 = { class: "px-3 py-2 align-middle whitespace-nowrap" }
const _hoisted_29 = { class: "inline-flex flex-wrap items-center justify-end gap-1" }
const _hoisted_30 = ["onClick", "disabled"]
const _hoisted_31 = ["onClick", "disabled"]
const _hoisted_32 = ["onClick", "disabled"]
const _hoisted_33 = { class: "mt-4 lg:hidden space-y-4 px-1 sm:px-2 pb-4" }
const _hoisted_34 = { class: "bg-gradient-to-r from-slate-50 to-slate-100 px-4 py-3 border-b border-slate-200" }
const _hoisted_35 = { class: "flex items-start justify-between gap-3" }
const _hoisted_36 = { class: "flex items-start gap-3 flex-1" }
const _hoisted_37 = { class: "flex-shrink-0 w-8 h-8 flex items-center justify-center bg-slate-200 rounded-full font-bold text-slate-700 text-sm" }
const _hoisted_38 = { class: "flex-1 min-w-0" }
const _hoisted_39 = { class: "font-bold text-slate-900 text-base" }
const _hoisted_40 = { class: "text-xs text-slate-500 mt-1" }
const _hoisted_41 = { class: "px-4 py-3 space-y-3" }
const _hoisted_42 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_43 = { class: "bg-slate-50 rounded-lg px-3 py-2" }
const _hoisted_44 = { class: "text-lg font-bold text-slate-900 mt-1" }
const _hoisted_45 = { class: "bg-slate-50 rounded-lg px-3 py-2" }
const _hoisted_46 = {
  key: 1,
  class: "inline-flex items-center px-2 py-1 rounded-full text-xs font-medium mt-1 bg-gray-100 text-gray-500"
}
const _hoisted_47 = { class: "bg-slate-50 rounded-lg px-3 py-2" }
const _hoisted_48 = { class: "text-sm text-slate-700 mt-1" }
const _hoisted_49 = { class: "text-sm text-slate-700" }
const _hoisted_50 = { class: "flex items-center justify-between py-2 px-3 bg-slate-50 rounded-lg" }
const _hoisted_51 = { class: "text-sm text-slate-700 font-medium" }
const _hoisted_52 = { class: "flex flex-wrap gap-2 pt-2" }
const _hoisted_53 = ["onClick", "disabled"]
const _hoisted_54 = ["onClick", "disabled"]
const _hoisted_55 = ["onClick", "disabled"]
const _hoisted_56 = {
  key: 0,
  class: "fixed bg-black bg-opacity-50 backdrop-blur-sm inset-0 z-50 overflow-y-auto",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_57 = { class: "flex min-h-full items-center justify-center p-4 text-center sm:p-0" }
const _hoisted_58 = { class: "relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all w-full max-w-lg" }
const _hoisted_59 = { class: "px-6 py-4" }
const _hoisted_60 = { class: "text-sm text-slate-600 text-center mb-4" }
const _hoisted_61 = { class: "font-semibold text-slate-900" }
const _hoisted_62 = { class: "bg-slate-50 px-6 py-4 flex flex-col-reverse sm:flex-row gap-3" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = ["disabled"]
const _hoisted_65 = { key: 0 }
const _hoisted_66 = {
  key: 1,
  class: "flex items-center justify-center gap-2"
}

import { ref, watch, computed } from "vue";
import { Pedido } from "../../interfaces/gpedPedido.inteface";

interface Props {
  pedidos: Pedido[];
  sortField: string | null;
  sortDirection: "asc" | "desc";
  isDelete?: boolean;
  currentPage?: number;
  pageSize?: number;
  /** Mientras el padre ejecuta PATCH «Pagado» (después de confirmar modal). */
  accionEnProceso?: boolean;
  /** Id del pedido en proceso (solo spinner en esa fila). */
  accionPedidoId?: string | null;
  /** Sincronización masiva Izipay en curso: bloquea acciones de la tabla. */
  sincronizandoIzipay?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'pedidosPendientesTable',
  props: {
    pedidos: {},
    sortField: {},
    sortDirection: {},
    isDelete: { type: Boolean },
    currentPage: { default: 1 },
    pageSize: { default: 10 },
    accionEnProceso: { type: Boolean, default: false },
    accionPedidoId: { default: null },
    sincronizandoIzipay: { type: Boolean, default: false }
  },
  emits: ["sort", "viewDetails", "updateEstado", "deletePedido"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showDeleteModal = ref(false);
const pedidoToDelete = ref<{ id: string; cliente: string } | null>(null);
const isDeleting = ref(false);

const tablaBloqueada = computed(
  () =>
    props.sincronizandoIzipay || props.accionEnProceso || isDeleting.value,
);

// Calcular el índice base según la página actual
const getGlobalIndex = (localIndex: number) => {
  return (props.currentPage - 1) * props.pageSize + localIndex + 1;
};

const formatDate = (dateString: string) =>
  new Date(dateString).toLocaleDateString("es-ES", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

const formatCurrency = (value: string) =>
  new Intl.NumberFormat("es-PE", {
    style: "currency",
    currency: "PEN",
  }).format(parseFloat(value));

const getEstadoClass = (estado: string) => {
  const estados: Record<string, string> = {
    "Pendiente": "bg-yellow-100 text-yellow-700",
    "Pagado": "bg-sky-100 text-sky-800",
    "En Proceso": "bg-blue-100 text-blue-700",
    "Completado": "bg-green-100 text-green-700",
    "Cancelado": "bg-red-100 text-red-700",
    "Entregado": "bg-purple-100 text-purple-700",
  };
  return estados[estado] || "bg-gray-100 text-gray-700";
};

const getMetodoPagoIcon = (metodo: string) => {
  if (metodo.toLowerCase().includes("efectivo")) {
    return "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z";
  } else if (metodo.toLowerCase().includes("tarjeta") || metodo.toLowerCase().includes("visa") || metodo.toLowerCase().includes("mastercard")) {
    return "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z";
  } else if (metodo.toLowerCase().includes("transferencia")) {
    return "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4";
  }
  return "M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z";
};

const openDeleteModal = (id: string, cliente: string) => {
  pedidoToDelete.value = { id, cliente };
  showDeleteModal.value = true;
};

const closeDeleteModal = () => {
  showDeleteModal.value = false;
  pedidoToDelete.value = null;
};

const confirmDelete = () => {
  if (!pedidoToDelete.value || isDeleting.value) return;
  isDeleting.value = true;
  emit("deletePedido", pedidoToDelete.value.id);
};

const handleUpdateEstado = (pedidoId: string) => {
  emit("updateEstado", pedidoId);
};

watch(
  () => props.isDelete,
  (newVal) => {
    if (newVal) {
      showDeleteModal.value = false;
      pedidoToDelete.value = null;
      isDeleting.value = false;
    }
  },
);

const getSortIcon = (field: string) => {
  if (props.sortField !== field) {
    return "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4";
  }
  return props.sortDirection === "asc"
    ? "M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
    : "M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("thead", _hoisted_5, [
            _createElementVNode("tr", null, [
              _cache[6] || (_cache[6] = _createElementVNode("th", { class: "w-10 px-3 py-3 text-left text-xs font-bold text-slate-600 uppercase tracking-wide bg-slate-50" }, " # ", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("th", { class: "px-3 py-3 min-w-[10rem] text-left text-xs font-bold text-slate-700 uppercase bg-slate-50" }, " Cliente ", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("th", { class: "px-3 py-3 w-28 text-left text-xs font-bold text-slate-700 uppercase bg-slate-50" }, " Doc. ", -1)),
              _cache[9] || (_cache[9] = _createElementVNode("th", { class: "px-3 py-3 w-32 text-left text-xs font-bold text-slate-700 uppercase bg-slate-50" }, " Comprob. ", -1)),
              _createElementVNode("th", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('sort', 'totalPedido'))),
                class: "px-3 py-3 w-28 text-left text-xs font-bold text-slate-700 uppercase cursor-pointer bg-slate-50 hover:bg-slate-200/80 transition-colors"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[3] || (_cache[3] = _createElementVNode("span", null, "Total", -1)),
                  (_openBlock(), _createElementBlock("svg", _hoisted_7, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: getSortIcon('totalPedido')
                    }, null, 8, _hoisted_8)
                  ]))
                ])
              ]),
              _createElementVNode("th", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('sort', 'estadoPedido'))),
                class: "px-3 py-3 w-32 text-left text-xs font-bold text-slate-700 uppercase cursor-pointer bg-slate-50 hover:bg-slate-200/80 transition-colors"
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", null, "Estado", -1)),
                  (_openBlock(), _createElementBlock("svg", _hoisted_10, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: getSortIcon('estadoPedido')
                    }, null, 8, _hoisted_11)
                  ]))
                ])
              ]),
              _createElementVNode("th", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('sort', 'createdAt'))),
                class: "px-3 py-3 min-w-[7.5rem] text-left text-xs font-bold text-slate-700 uppercase cursor-pointer bg-slate-50 hover:bg-slate-200/80 transition-colors"
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", null, "Fecha", -1)),
                  (_openBlock(), _createElementBlock("svg", _hoisted_13, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: getSortIcon('createdAt')
                    }, null, 8, _hoisted_14)
                  ]))
                ])
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("th", { class: "px-3 py-3 w-36 text-left text-xs font-bold text-slate-700 uppercase bg-slate-50" }, " Acciones ", -1))
            ])
          ]),
          _createElementVNode("tbody", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.pedidos, (pedido, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: pedido.id,
                class: "hover:bg-slate-50 transition-colors"
              }, [
                _createElementVNode("td", _hoisted_16, _toDisplayString(getGlobalIndex(index)), 1),
                _createElementVNode("td", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(pedido.cliente.nombreCliente) + " " + _toDisplayString(pedido.cliente.apellidoCliente), 1),
                  _createElementVNode("div", {
                    class: "text-xs text-slate-500 mt-0.5 truncate",
                    title: pedido.cliente.correoCliente
                  }, _toDisplayString(pedido.cliente.correoCliente), 9, _hoisted_19)
                ]),
                _createElementVNode("td", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(pedido.cliente.nroDocumento), 1)
                ]),
                _createElementVNode("td", _hoisted_22, [
                  (pedido.tipoComprobante)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["inline-flex max-w-full items-center px-2 py-0.5 rounded-full text-xs font-medium truncate", pedido.tipoComprobante === 'Factura' ? 'bg-blue-100 text-blue-700' : 'bg-green-100 text-green-700'])
                      }, _toDisplayString(pedido.tipoComprobante), 3))
                    : (_openBlock(), _createElementBlock("span", _hoisted_23, " N/A "))
                ]),
                _createElementVNode("td", _hoisted_24, _toDisplayString(formatCurrency(pedido.totalPedido)), 1),
                _createElementVNode("td", _hoisted_25, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["inline-flex max-w-full items-center px-2.5 py-0.5 rounded-full text-xs font-medium truncate", getEstadoClass(pedido.estadoPedido.nombre)]),
                    title: pedido.estadoPedido.nombre
                  }, _toDisplayString(pedido.estadoPedido.nombre), 11, _hoisted_26)
                ]),
                _createElementVNode("td", _hoisted_27, _toDisplayString(formatDate(pedido.createdAt)), 1),
                _createElementVNode("td", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (emit('viewDetails', pedido.id)),
                      disabled: tablaBloqueada.value,
                      class: "p-2 text-green-600 hover:bg-green-50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed",
                      title: "Ver detalles"
                    }, [...(_cache[11] || (_cache[11] = [
                      _createElementVNode("svg", {
                        class: "w-5 h-5",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        }),
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        })
                      ], -1)
                    ]))], 8, _hoisted_30),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (handleUpdateEstado(pedido.id)),
                      disabled: tablaBloqueada.value,
                      class: "p-2 text-blue-600 hover:bg-blue-50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed",
                      title: "Marcar como pagado (pasa a Pedidos pagados)"
                    }, [
                      (_openBlock(), _createElementBlock("svg", {
                        class: _normalizeClass(["w-5 h-5", {
                    'animate-spin':
                      __props.accionEnProceso && __props.accionPedidoId === pedido.id,
                  }]),
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [...(_cache[12] || (_cache[12] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                        }, null, -1)
                      ]))], 2))
                    ], 8, _hoisted_31),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (openDeleteModal(pedido.id, `${pedido.cliente.nombreCliente} ${pedido.cliente.apellidoCliente}`)),
                      disabled: tablaBloqueada.value,
                      class: "p-2 text-red-600 hover:bg-red-50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed",
                      title: "Eliminar pedido"
                    }, [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("svg", {
                        class: "w-5 h-5",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        })
                      ], -1)
                    ]))], 8, _hoisted_32)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.pedidos, (pedido, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: pedido.id,
          class: "bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden hover:shadow-md transition-shadow"
        }, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("span", _hoisted_37, _toDisplayString(getGlobalIndex(index)), 1),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("h3", _hoisted_39, _toDisplayString(pedido.cliente.nombreCliente) + " " + _toDisplayString(pedido.cliente.apellidoCliente), 1),
                  _createElementVNode("p", _hoisted_40, _toDisplayString(pedido.cliente.nroDocumento), 1)
                ])
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(["inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium", getEstadoClass(pedido.estadoPedido.nombre)])
              }, _toDisplayString(pedido.estadoPedido.nombre), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase block" }, "Total", -1)),
                _createElementVNode("p", _hoisted_44, _toDisplayString(formatCurrency(pedido.totalPedido)), 1)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase block" }, "Comprobante", -1)),
                (pedido.tipoComprobante)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["inline-flex items-center px-2 py-1 rounded-full text-xs font-medium mt-1", pedido.tipoComprobante === 'Factura' ? 'bg-blue-100 text-blue-700' : 'bg-green-100 text-green-700'])
                    }, _toDisplayString(pedido.tipoComprobante), 3))
                  : (_openBlock(), _createElementBlock("span", _hoisted_46, " N/A "))
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase block" }, "Contacto", -1)),
              _createElementVNode("p", _hoisted_48, _toDisplayString(pedido.cliente.correoCliente), 1),
              _createElementVNode("p", _hoisted_49, _toDisplayString(pedido.cliente.telefono), 1)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase" }, "Fecha", -1)),
              _createElementVNode("span", _hoisted_51, _toDisplayString(formatDate(pedido.createdAt)), 1)
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("button", {
                onClick: ($event: any) => (emit('viewDetails', pedido.id)),
                disabled: tablaBloqueada.value,
                class: "flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-green-50 text-green-700 rounded-lg hover:bg-green-100 transition-colors font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed"
              }, [...(_cache[18] || (_cache[18] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  }),
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                  })
                ], -1),
                _createTextVNode(" Ver ", -1)
              ]))], 8, _hoisted_53),
              _createElementVNode("button", {
                onClick: ($event: any) => (handleUpdateEstado(pedido.id)),
                disabled: tablaBloqueada.value,
                class: "flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition-colors font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed"
              }, [
                (_openBlock(), _createElementBlock("svg", {
                  class: _normalizeClass(["w-4 h-4", {
                  'animate-spin': __props.accionEnProceso && __props.accionPedidoId === pedido.id,
                }]),
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [...(_cache[19] || (_cache[19] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  }, null, -1)
                ]))], 2)),
                _cache[20] || (_cache[20] = _createTextVNode(" Pagado ", -1))
              ], 8, _hoisted_54),
              _createElementVNode("button", {
                onClick: ($event: any) => (openDeleteModal(pedido.id, `${pedido.cliente.nombreCliente} ${pedido.cliente.apellidoCliente}`)),
                disabled: tablaBloqueada.value,
                class: "px-4 py-2.5 bg-red-50 text-red-700 rounded-lg hover:bg-red-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
                title: "Eliminar pedido"
              }, [...(_cache[21] || (_cache[21] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  })
                ], -1)
              ]))], 8, _hoisted_55)
            ])
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (showDeleteModal.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
              _createElementVNode("div", {
                class: "fixed inset-0 transition-opacity",
                onClick: closeDeleteModal
              }),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "bg-gradient-to-br from-red-50 to-rose-50 px-6 pt-6 pb-4" }, [
                    _createElementVNode("div", { class: "flex items-center justify-center w-16 h-16 mx-auto bg-red-100 rounded-full" }, [
                      _createElementVNode("svg", {
                        class: "w-8 h-8 text-red-600",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        })
                      ])
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_59, [
                    _cache[23] || (_cache[23] = _createElementVNode("h3", {
                      class: "text-xl font-bold text-slate-900 text-center mb-2",
                      id: "modal-title"
                    }, " ¿Eliminar Pedido? ", -1)),
                    _createElementVNode("p", _hoisted_60, [
                      _cache[22] || (_cache[22] = _createTextVNode(" Estás a punto de eliminar el pedido del cliente ", -1)),
                      _createElementVNode("span", _hoisted_61, "\"" + _toDisplayString(pedidoToDelete.value?.cliente) + "\"", 1)
                    ]),
                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "bg-amber-50 border-l-4 border-amber-400 p-4 rounded" }, [
                      _createElementVNode("div", { class: "flex gap-3" }, [
                        _createElementVNode("svg", {
                          class: "w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          })
                        ]),
                        _createElementVNode("p", { class: "text-sm text-amber-800" }, " Esta acción no se puede deshacer. Se eliminarán todos los detalles asociados a este pedido. ")
                      ])
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: closeDeleteModal,
                      disabled: isDeleting.value,
                      class: "flex-1 px-4 py-2.5 bg-white border-2 border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                    }, " Cancelar ", 8, _hoisted_63),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: confirmDelete,
                      disabled: isDeleting.value,
                      class: _normalizeClass(["flex-1 px-4 py-2.5 rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 shadow-sm", {
                  'bg-red-600 text-white hover:bg-red-700': !isDeleting.value,
                  'bg-red-400 text-white opacity-70 cursor-not-allowed': isDeleting.value,
                }])
                    }, [
                      (!isDeleting.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_65, "Sí, eliminar"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_66, [...(_cache[25] || (_cache[25] = [
                            _createElementVNode("svg", {
                              class: "animate-spin w-4 h-4 text-white",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("circle", {
                                class: "opacity-25",
                                cx: "12",
                                cy: "12",
                                r: "10",
                                stroke: "currentColor",
                                "stroke-width": "4"
                              }),
                              _createElementVNode("path", {
                                class: "opacity-75",
                                fill: "currentColor",
                                d: "M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l3 3-3 3v-4a8 8 0 01-8-8z"
                              })
                            ], -1),
                            _createTextVNode(" Eliminando... ", -1)
                          ]))]))
                    ], 10, _hoisted_64)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})